import { render } from "./WorkSheet.vue?vue&type=template&id=6cdaf9ba"
import script from "./WorkSheet.vue?vue&type=script&lang=js"
export * from "./WorkSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__